/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ConduitSettingsItemNumberTagModule } from './conduit-settings-item-number-tag.module';
export { ConduitSettingsItemNumberTagComponent } from './conduit-settings-item-number-tag.component';